module.exports = __webpack_public_path__ + "static/media/tadoo-logo.1c928b53.png";